import * as Sentry from "@sentry/browser";
import {
  BillingAccount,
  BillingAPIError,
} from "@screencloud/studio-billing-sdk/client";
import {
  BillingV2NotConfiguredError,
  getBillingV2Client,
} from "src/domains/billing/billingClient";

/**
 * Which billing an org uses, read from billing v2 `me.get()`.
 *
 * @remarks
 * 200 means v2. 404 means the org is not on billing v2, so it is v1. Any other error fails open as v1, so existing
 * orgs keep today's behaviour when billing v2 has problems.
 */
export type BillingVersionResult =
  | { version: "v2"; account: BillingAccount }
  | { version: "v1" };

export const getBillingVersion = async (): Promise<BillingVersionResult> => {
  try {
    const account = await getBillingV2Client().me.get();
    return { version: "v2", account };
  } catch (error) {
    if (error instanceof BillingV2NotConfiguredError) {
      return { version: "v1" };
    }
    if (error instanceof BillingAPIError && error.status === 404) {
      return { version: "v1" };
    }
    // Fail open: treat as v1, but report it so a billing v2 outage is noticed.
    Sentry.captureException(error);
    return { version: "v1" };
  }
};
